module.exports = __webpack_public_path__ + "23bd6bbc17afd19f9887145926ebe1a4.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/report.png
// module id = 589
// module chunks = 0